export default __webpack_public_path__ + "static/kenigbolo_meya_stephen-b89ed3399e87bddd19f3f1d0223dbdad.jpg";